export const libsHeaders = [
  { text: "Set", value: "node.set" },
  { text: "SetDesc", value: "node.setDesc" },
  { text: "setPurpose", value: "node.setPurpose" },
  { text: "Ezone", value: "node.activityId" },
  { text: "tag", value: "node.tag" },
  { text: "SportType", value: "node.sportType" },
  { text: "equipment", value: "node.equipment", sort: true },
  { text: "Actions", value: "action", sortable: false }
];

export const libsDefaultItem = {
  name: "",
  desc: "",
  purpose: "",
  status: "",
  tag: "",
  equipment: "",
  sportType: "",
  facilityType: "",
  userId: null,
  teamId: null
};
